import { useEffect } from 'react';
import { Image, Text } from '@vinted/web-ui';
import Notification from 'components/Notification';
import { jsx as _jsx } from "react/jsx-runtime";
const ONE_SECOND_IN_MILISECONDS = 1000;

const NotificationInAppMessage = _ref => {
  let {
    inAppMessage,
    onClose,
    onLinkClick,
    onEnter
  } = _ref;
  useEffect(onEnter, [onEnter]);

  const buildLink = children => {
    if (!inAppMessage.url) return children;
    const target = inAppMessage.shouldOpenLinkInNewTab ? '_target' : undefined;
    return /*#__PURE__*/_jsx("a", {
      href: inAppMessage.url,
      target: target,
      onClick: onLinkClick,
      children: children
    });
  };

  const renderBody = () => {
    return buildLink( /*#__PURE__*/_jsx(Text, {
      text: inAppMessage.message,
      html: true
    }));
  };

  const renderImage = () => {
    if (!inAppMessage.imageUrl) return undefined;
    return buildLink( /*#__PURE__*/_jsx(Image, {
      src: inAppMessage.imageUrl,
      size: Image.Size.Large
    }));
  };

  const miliSecondsToSeconds = duration => Math.ceil(duration / ONE_SECOND_IN_MILISECONDS);

  return /*#__PURE__*/_jsx(Notification, {
    deprecatedIcon: renderImage(),
    body: renderBody(),
    displayDuration: inAppMessage.duration && miliSecondsToSeconds(inAppMessage.duration),
    forceVisibility: !inAppMessage.duration,
    position: inAppMessage.position,
    onNotificationClose: onClose,
    testId: "in-app-message-notification"
  });
};

export default NotificationInAppMessage;